const doc = [({"en":({"js":({"admin":({"school_classes":({"index":({"the_school_class_was_deleted":"The school class was deleted"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;